module.exports = __webpack_public_path__ + "img/template2.f868567b.webp";